import { sanityClient } from '@/lib/sanity/client';

export async function sanityFetchClient<Result = any>(options: {
  query: string;
  params?: Record<string, any>;
}) {
  let isDraftMode: boolean;

  try {
    isDraftMode = document.cookie.includes('__prerender_bypass');
  } catch {
    isDraftMode = false;
  }

  const response = await sanityClient.fetch(options.query, options.params, {
    ...(isDraftMode && {
      token: process.env.NEXT_PUBLIC_SANITY_API_READ_TOKEN,
      perspective: 'drafts',
      stega: true,
      useCdn: false,
    }),
  });

  return { data: response as Result };
}
